
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { cloneDeep } from "lodash";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import FormGroup from "@/components/form/FormGroup.vue";
import Checkbox from "@/components/form/Checkbox.vue";
import ProjectCriteriaMultiselect from "@/components/scheduler/schedulerSelects/ProjectCriteriaMultiselect.vue";
import ProjectStatusSelect from "@/components/scheduler/schedulerSelects/ProjectStatusSelect.vue";
import ProfileCountrySelect from "@/components/autocompleteMultiselects/ProfileCountrySelect.vue";
import ProjectCityMultiselect from "@/components/autocompleteMultiselects/ProjectCityMultiselect.vue";
import RegionInput from "@/components/autocompleteMultiselects/RegionInputNew.vue";
import ProjectsMultiselect from "@/components/autocompleteMultiselects/ProjectsMultiselect.vue";
import DropdownIndicator from "@/components/icons/DropdownIndicator.vue";
import { Project } from "@/generated/graphql";
import Roles from "@/entities/Roles";
import {
  getEmptyFiltersResultMessage,
  getEmptyListMessage,
} from "@/helpers/lists/emptyListMessagesNew";
import ProjectAdditionalFilters from "@/entities/scheduler/additionalFiltersInterfaces/ProjectAdditionalFilters";
import projectViewFiltersTemplate from "@/data/filtersTemplates/scheduler/projectViewFiltersTemplate";
import DateRange from "@/entities/scheduler/DateRange";
import moment from "moment";
import UIButton from "@/components/button/ui-button.vue";
import CustomButton from "@/components/new/buttons/CustomButton.vue";
import FormDatepicker from "@/components/form/FormDatepicker.vue";
import DropdownOption from "@/entities/DropdownOption";
@Component({
  components: {
    FormGroup,
    Checkbox,
    ProjectCriteriaMultiselect,
    ProjectStatusSelect,
    ProjectsMultiselect,
    ProjectCityMultiselect,
    RegionInput,
    ProfileCountrySelect,
    UIButton,
    CustomButton,
    ModalFullScreen,
    DropdownIndicator,
    FormDatepicker,
  },
})
export default class ProjectAdvancedFilter extends Vue {
  @Prop({ type: String, required: true }) readonly currentUserRole!: Roles;
  @Prop({ type: Boolean, default: false })
  readonly shouldClearFilters!: boolean;
  @Prop({ type: Boolean, default: false }) readonly show!: boolean;
  @Prop({ type: Boolean, default: true }) readonly showProjects!: boolean;

  projects: Project[] = [];
  filterFields: ProjectAdditionalFilters = cloneDeep(
    projectViewFiltersTemplate
  );

  selectedProjectsIds: string[] = [];
  //wip 3
  rangeStart: Date = new Date();
  // rangeEnd: Date = moment(this.rangeStart).add(1, "M").toDate();
  rangeEnd: Date = this.rangeStart;

  //wip 3 end
  showActivitiesCheckbox = {
    name: "Show Activities",
    id: "showActivities",
    selected: false,
  };
  //wip 3.1 end
  dateRangeFilter: string = null;

  created(): void {
    this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  }
  updateFiltersSelectedProjects(options: DropdownOption[], ids: string[]) {
    this.selectedProjectsIds = ids
    this.filterFields.projects = options
  }

  @Watch("shouldClearFilters")
  handleClearFilters(value: boolean): void {
    if (value === true) {
      this.clearFilters();
      this.$emit("filtersReset");
    }
  }

  //   @Watch("propToWatch")
  //   handlePropToWatchChange(): void {
  //     this.$emit("filtersChanged", {
  //       countries: this.countriesNames,
  //       states: this.statesNames,
  //       cities: this.citiesNames,
  //       criteria: this.filterFields.criteria,
  //       status: this.filterFields.status,
  //     });
  //   }

  //   @Watch("numberOfAppliedFilters", { immediate: true })
  //   appliedFiltersChanged() {
  //     this.$emit("appliedFiltersNumberChanged", this.numberOfAppliedFilters);
  //   }

  //   @Watch("showActivities")
  //   showActivitiesToggle(): void {
  //     this.$emit("showActivitiesToggle", this.showActivities);
  //   }

  //   @Watch("dateRange")
  //   handleDateRange() {
  //     this.$emit("rangeStart", this.rangeStart);
  //     this.$emit("rangeEnd", this.rangeEnd);
  //   }

  get numberOfAppliedFilters(): any {
    const appliedFiltersQuantity = {
      countries: this.filterFields.countries.length ? 1 : 0,
      states: this.filterFields.states.length ? 1 : 0,
      cities: this.filterFields.cities.length ? 1 : 0,
      criteria: this.filterFields.criteria.length ? 1 : 0,
      projects: this.filterFields.projects?.length ? 1 : 0,
      status:
        this.filterFields.status.length &&
          this.filterFields.status[0].id !== "All"
          ? 1
          : 0,
    };

    return Object.values(appliedFiltersQuantity).reduce(
      (prevValue, curValue) => {
        return prevValue + curValue;
      },
      0
    );
  }

  get loading(): boolean {
    return this.$apollo.queries.projects.loading && !this.projects.length;
  }

  get customPlaceholderMessage(): string {
    if (this.numberOfAppliedFilters && !this.projects.length) {
      return getEmptyFiltersResultMessage("projects");
    }
    return getEmptyListMessage("projects");
  }

  get dateRange(): DateRange {
    return {
      startDate: this.rangeStart,
      endDate: this.rangeEnd,
    };
  }

  get countriesNames(): string[] {
    return this.filterFields.countries.filter(s => !!s.name.trim()).map((country) => country.name);
  }

  get statesNames(): string[] {
    return this.filterFields.states.filter(s => !!s.name.trim()).map((state) => state.name);
  }

  get citiesNames(): string[] {
    return this.filterFields.cities.filter(s => !!s.name.trim()).map((city) => city.name);
  }
  get projectIds(): string[] {
    return this.filterFields.projects.filter(s => !!s.id.trim()).map(p => p.id);
  }

  get propToWatch(): string {
    return JSON.stringify([
      this.filterFields.countries,
      this.filterFields.states,
      this.filterFields.cities,
      this.filterFields.criteria,
      this.filterFields.status,
      this.filterFields.projects,
    ]);
  }

  get isManager(): boolean {
    return this.currentUserRole === Roles.MANAGER;
  }

  get showActivities(): boolean {
    return this.showActivitiesCheckbox.selected;
  }
  //wip 4
  handleDateRangeChange(date: DateRange) {
    this.rangeStart = date.startDate;
    this.rangeEnd = date.endDate;
    this.dateRangeFilter = `${moment(this.rangeStart).format(
      "MM/DD/YYYY"
    )} - ${moment(this.rangeEnd).format("MM/DD/YYYY")}`;
  }
  // wip 4 end

  clearFilters(): void {
    this.selectedProjectsIds = []
    this.filterFields = cloneDeep(projectViewFiltersTemplate);
    //wip 3
    this.rangeStart = new Date();
    // this.rangeEnd=  moment(this.rangeStart).add(1, "M").toDate();
    this.rangeEnd = this.rangeStart;

  }

  applyFilters(): void {
    this.$emit("apply-filters", {
      countries: this.countriesNames,
      states: this.statesNames,
      cities: this.citiesNames,
      criteria: this.filterFields.criteria,
      status: this.filterFields.status,
      rangeStart: this.rangeStart,
      rangeEnd: this.rangeEnd,
      showActivities: this.showActivities,
      projects: this.projectIds,
    });
    this.closeModal();
  }
  closeModal(): void {
    this.$emit("close");
  }
}
